import type { ReactNode } from 'react';

export const symbol_tile_large: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-150v-165q0-12 9-21t21-9h248q12 0 21 9t9 21v165q0 12.75-8.62 21.37Q410.75-120 398-120H150q-12.75 0-21.37-8.63Q120-137.25 120-150Zm413 0v-165q0-12.75 8.63-21.38Q550.25-345 563-345h247q12.75 0 21.38 8.62Q840-327.75 840-315v165q0 12.75-8.62 21.37Q822.75-120 810-120H563q-12.75 0-21.37-8.63Q533-137.25 533-150ZM120-480v-330q0-12.75 8.63-21.38Q137.25-840 150-840h660q12.75 0 21.38 8.62Q840-822.75 840-810v330q0 12.75-8.62 21.37Q822.75-450 810-450H150q-12.75 0-21.37-8.63Q120-467.25 120-480Zm60 300h188v-105H180v105Zm413 0h187v-105H593v105Zm-319-53Zm413 0Z"
		/>
	</svg>
);
